import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.dataProcessingMerge;

const dataProcessingMergeData = createSelector([selector], (state) => state);

export default {
  dataProcessingMergeData
};
